export const languageCodes = {
  english: "en",
  français: "fr",
  español: "es",
  中文: "zh",
  日本語: "jp",
  português: "pt",
  deutsch: "de",
  العربية: "ar",
  русский: "ru",
  italiano: "it",
  한국어: "ko",
  nederlands: "nl",
  türkçe: "tr",
};